import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  flows: [],
  currentFlow: null,
  loading: false,
  error: null,
  // Builder state
  selectedNodeId: null,
  isDirty: false,
};

const flowSlice = createSlice({
  name: 'flows',
  initialState,
  reducers: {
    setFlows(state, action) {
      state.flows = action.payload;
      state.loading = false;
      state.error = null;
    },
    setCurrentFlow(state, action) {
      state.currentFlow = action.payload;
      state.isDirty = false;
    },
    updateCurrentFlow(state, action) {
      state.currentFlow = { ...state.currentFlow, ...action.payload };
      state.isDirty = true;
    },
    setSelectedNode(state, action) {
      state.selectedNodeId = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    markClean(state) {
      state.isDirty = false;
    },
    clearCurrentFlow(state) {
      state.currentFlow = null;
      state.selectedNodeId = null;
      state.isDirty = false;
    },
  },
});

export const {
  setFlows,
  setCurrentFlow,
  updateCurrentFlow,
  setSelectedNode,
  setLoading,
  setError,
  markClean,
  clearCurrentFlow,
} = flowSlice.actions;

export default flowSlice.reducer;
